const productUrls = {
    test: {
        pos: {
            desktop: 'https://pos-qa.simprasuite.com/?skipRedirection=true',
            mobile: 'https://pos-qa.simprasuite.com/?skipRedirection=true'
        },
        inventory: {
            desktop: 'https://test-inventory.simprasuite.com/?skipRedirection=true',
            mobile: 'https://m-test-inventory.simprasuite.com/#/login'
        },
        link: {
            desktop: 'https://test-backoffice.simpralink.com/?skipRedirection=true',
            mobile: 'https://simprasuite.com.tr/link/'
        },
        'c&p': {
            desktop: 'https://test.checkandplace.com/?skipRedirection=true',
            mobile: 'https://test.checkandplace.com/?skipRedirection=true',
        },
        loyalty: {
            desktop: 'https://loyalty-test.simprasuite.com/?skipRedirection=true',
            mobile: null
        },
        'vendormarket': {
            desktop: 'https://market-test.simprasuite.com/',
            mobile: 'https://market-test.simprasuite.com/',
        }
    },
    staging: {
        pos: {
            desktop: 'https://pos-uat.simprasuite.com/?skipRedirection=true',
            mobile: 'https://pos-uat.simprasuite.com/?skipRedirection=true'
        },
        inventory: {
            desktop: 'https://staging-inventory.simprasuite.com/?skipRedirection=true',
            mobile: 'https://m-staging-inventory.simprasuite.com/#/login'
        },
        link: {
            desktop: 'https://staging-backoffice.simpralink.com/?skipRedirection=true',
            mobile: 'https://simprasuite.com.tr/link/'
        },
        'c&p': {
            desktop: 'https://staging.checkandplace.com/?skipRedirection=true',
            mobile: 'https://staging.checkandplace.com/?skipRedirection=true',
        },
        loyalty: {
            desktop: 'https://loyalty-staging.simprasuite.com/?skipRedirection=true',
            mobile: null
        },
        'vendormarket': {
            desktop: 'https://market-staging.simprasuite.com/',
            mobile: 'https://market-staging.simprasuite.com/',
        },
    },
    production: {
        pos: {
            desktop: 'https://pos.simprasuite.com/?skipRedirection=true',
            mobile: 'https://pos.simprasuite.com/?skipRedirection=true'
        },
        inventory: {
            desktop: 'https://inventory.simprasuite.com/?skipRedirection=true',
            mobile: 'https://m-inventory.simprasuite.com/#/login'
        },
        link: {
            desktop: 'https://backoffice.simpralink.com/?skipRedirection=true',
            mobile: 'https://simprasuite.com.tr/link/'
        },
        'c&p': {
            desktop: 'https://www.checkandplace.com/?skipRedirection=true',
            mobile: 'https://www.checkandplace.com/?skipRedirection=true',
        },
        loyalty: {
            desktop: 'https://loyalty.simprasuite.com/?skipRedirection=true',
            mobile: null
        },
        'vendormarket': {
            desktop: 'https://market.simprasuite.com/',
            mobile: 'https://market.simprasuite.com/',
        }
    },
}

export default productUrls